import { ReactComponent as ChevronIconSVG } from '@/assets/icons/ChevronIcon.svg';
import { SVGProps } from 'react';

const ChevronIcon = (props: SVGProps<SVGSVGElement>) => <ChevronIconSVG {...props} />;

export default ChevronIcon;
